import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../components/States/AppContext";

//components
import { NumericBox1 } from "../../components/MainButtons/NumericBoxes";
import LockBox from "../../components/MainButtons/LockBox";
import PrimaryWave from "../../components/MainButtons/PrimaryWave";
import SecondaryWave from "../../components/MainButtons/SecondaryWave";
import skeleton from "../../img/misc/skeleton.png";

//landscape pages
import LandscapePage from "../Landscape/LandscapePage";
import LandscapeMultiLead from "../Landscape/LandscapeMultiLead";

// styles
import {
  GridMain1,
  GridMain2,
  GridMain3,
  GridMain6,
  ImgSkeleton,
  Sweep,
} from "./MainScreen.elements";

const MainScreen1 = () => {
  const { state, setState } = useContext(AppContext);

  /*
    First monitor screen.

    Has parameter selection for top wave in top left. Default HR.

    Has parameter selection for bottom wave in bottom left. Default SpO2.
  */

  return (
    <>
      <LockBox />

      {state.relearn && (
        <div
          style={{
            width: "100%",
            height: "50%",
            position: "absolute",
            top: "50%",
            zIndex: "100000",
          }}
        >
          <Sweep />
        </div>
      )}

      <GridMain1>
        <NumericBox1 number={1} />
        <NumericBox1 number={2} />
        <PrimaryWave cache="none" rel="preload" />
        <SecondaryWave cache="none" rel="preload" />
      </GridMain1>
    </>
  );
};

const MainScreen2 = () => {
  /*
    Second visible screen. Has only 1 waveform and 2 other readouts in the bottom left/r

  */
  return (
    <>
      <LockBox />
      <GridMain2>
        <NumericBox1 number={1} />
        <NumericBox1 number={2} />
        <PrimaryWave />
        <NumericBox1 number={3} />
        <NumericBox1 number={4} />
      </GridMain2>
    </>
  );
};

const MainScreen3 = () => {
  /*

  Third screen.

  Has 6 numeric readouts and no waveforms.

  */

  return (
    <>
      <LockBox />
      <GridMain3>
        <NumericBox1 number={1} />
        <NumericBox1 number={2} />
        <NumericBox1 number={3} />
        <NumericBox1 number={4} />
        <NumericBox1 number={5} />
        <NumericBox1 number={6} />
      </GridMain3>
    </>
  );
};

const MainScreen4 = () => {
  /*
    Fourth screen, first landscape. 

    SHOULD have two waveforms. TODO: where is second waveform?

  */

  return (
    <>
      <LockBox />
      <LandscapePage />
    </>
  );
};

const MainScreen5 = () => {
  return (
    <>
      <LockBox />
      <LandscapeMultiLead></LandscapeMultiLead>
    </>
  );
};

const MainScreen6 = () => {
  return (
    <>
      <LockBox />

      <GridMain6>
        <NumericBox1 number={1} />
        <NumericBox1 number={2} />
        <ImgSkeleton src={skeleton}></ImgSkeleton>
      </GridMain6>
    </>
  );
};

const MainScreenPages = [
  MainScreen1,
  MainScreen2,
  MainScreen3,
  MainScreen4,
  MainScreen5,
  MainScreen6,
];

export default MainScreenPages;
